import { getBomDatawithAssociatedBoms } from '@/api'

export async function checkForCyclicDependency (bomVersionId, parentProdCode) {
  if (!parentProdCode) return false
  try {
    let versionIdsToCheck = [bomVersionId]
    const visited = new Set()
    let depth = 0
    const MAX_DEPTH = 50

    while (versionIdsToCheck.length > 0) {
      if (depth > MAX_DEPTH) {
        return true
      }
      depth++

      const nextBatch = []

      for (const vId of versionIdsToCheck) {
        if (visited.has(vId)) continue
        visited.add(vId)

        const data = await getBomDatawithAssociatedBoms(vId, false)
        if (!data || !data.bom_items) continue

        for (let i = 0; i < data.bom_items.length; i++) {
          if (data.bom_items[i]?.core_material?.product_code === parentProdCode) {
            return true
          }
          if (data.bom_items[i]?.associated_bom_version?.id) {
            nextBatch.push(data.bom_items[i].associated_bom_version.id)
          }
        }
      }
      versionIdsToCheck = nextBatch
    }
    return false
  } catch (err) {
    console.error('Error checking cyclic dependency:', err)
    return false
  }
}
